import React, { useState, useEffect } from 'react';
import { UserDetail } from 'appDtos';

export interface AddedAccountDetailProps {
  isExpanded: boolean;
  account: UserDetail;
  removeAccount: (onlineOneUserId: number) => Promise<void>;
}

export const AddedAccountDetail = (props: AddedAccountDetailProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  useEffect(() => {
    // Listen for "Show/Hide All" prop from parent.
    setIsExpanded(prev => prev !== props.isExpanded ? props.isExpanded : prev);
  }, [props.isExpanded]);

  const toggleExpansion = () => setIsExpanded((prev) => !prev);
  const nsClassName = isExpanded ? 'ns-icon ns-collapse' : 'ns-icon ns-expand';
  
  const ariaTarget = `collapsable-details-${props.account.userId}`;

  const moreDetails = (
    <>
    <div className="account-details">
      <div className="col-xs-12 col-sm-12" data-testid="more-details-header">
        <h3>More Details</h3>
      </div>
      <div className="col-xs-12 col-sm-12">
        Email
      </div>
      <div className="col-xs-12 col-sm-12" data-testid="more-details-email">
        {props.account.email}
      </div>
      <div className="col-lg-2 col-md-3 col-sm-4 col-xs-4">
        <button
          title="Remove"
          data-testid={`remove_btn_${props.account.userId}`}
          id={`btn_${props.account.userId}`}
          className="btn btn-link no-padding btn-Remove"
          onClick={() => props.removeAccount(props.account.userId)}
        >
          Remove
        </button>
      </div>
    </div>
    </>
  );

  return (
    <div className="item-detail" data-testid="item-detail">
      <div className="row">
        <div className="visible-sm visible-xs col-lg-3 col-md-3 col-sm-2 col-xs-4 text-right">
            <button className={`btn btn-link ${nsClassName}`} onClick={toggleExpansion} type="button" aria-expanded={isExpanded} aria-controls={ariaTarget} data-testid="expand-details-button"/>
        </div>
      </div>
      <div id={ariaTarget} className="row more-details" data-testid="more-details">
        {isExpanded && moreDetails}
      </div>
    </div>
  );
};